import { HttpErrorResponse } from '@angular/common/http';

export function errorMessage(
  preface: string,
  error: any,
  addNewLineAfterErrorStatus = true,
  customErrorMessage?: string,
): string {
  let result = preface;
  if (error instanceof HttpErrorResponse) {
    if (!error.status) {
      result += `\n${customErrorMessage ?? 'Could not connect to Rivet'}`;
    } else {
      result += `\nHTTP error ${error.status}`;
      if (error.error) {
        result += addNewLineAfterErrorStatus ? ':\n' : ': ';
        result += `${error.error}`;
      }
    }
  } else if (error instanceof Error && error.message) {
    result += `\n${error.message}`;
  } else if (typeof error == 'string') {
    result += `\n${error}`;
  }
  return result;
}
